import RestaurantDraftList from "./RestaurantDraftList";
import RestaurantDraftEdit from "./RestaurantDraftEdit";
import RestaurantDraftShow from "./RestaurantDraftShow";

const restaurantsDraft = {
  list: RestaurantDraftList,
  edit: RestaurantDraftEdit,
  show: RestaurantDraftShow,
};

export default restaurantsDraft;
